import { useState } from "react";
import { BadgeCheck, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, formatErr } from "@/lib/api";

const tomorrow = () => { const d = new Date(); d.setDate(d.getDate() + 1); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`; };

export function RenewDialog({ doc, onClose, onSaved }) {
  const [file, setFile] = useState(null);
  const [d, setD] = useState("");
  const [busy, setBusy] = useState(false);
  if (!doc) return null;
  const save = async () => {
    setBusy(true);
    const fd = new FormData();
    fd.append("file", file);
    fd.append("expires_on", d);
    try {
      const r = await api.post(`/documents/${doc.doc_id}/renew`, fd);
      toast.success("Renewal saved. Your reminders now follow the new expiry date.");
      onSaved?.(r.data); onClose();
    } catch (e) { toast.error(formatErr(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-sm w-[calc(100%-2rem)]" data-testid="renew-dialog">
        <DialogHeader><DialogTitle className="flex items-center gap-2"><BadgeCheck className="h-5 w-5 text-emerald-600" />Mark as renewed</DialogTitle></DialogHeader>
        <p className="text-sm text-slate-600 break-words">Upload the new copy of <b>{doc.filename.replace(/\.[^.]+$/, "").replace(" (scan)", "")}</b>. The old one stays in your vault as history.</p>
        <label className="text-sm font-medium text-slate-700">New document (PDF or photo)</label>
        <Input type="file" accept=".pdf,.png,.jpg,.jpeg,.doc,.docx" onChange={(e) => setFile(e.target.files?.[0] || null)} className="h-11 pt-2" data-testid="renew-file-input" />
        <label className="text-sm font-medium text-slate-700">New expiry date</label>
        <Input type="date" min={tomorrow()} value={d} onChange={(e) => setD(e.target.value)} className="h-11" data-testid="renew-date-input" />
        <Button onClick={save} disabled={busy || !file || !d} className="h-11 bg-emerald-600 hover:bg-emerald-700" data-testid="renew-save">{busy && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}Save renewal</Button>
      </DialogContent>
    </Dialog>
  );
}
